import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useState} from 'react';

import {TagSchema} from 'constants/RegistryConstants';
import {GRAY, GRAY_SEMIDARK, NEAR_BLACK} from 'ui-library/Colors';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

interface RestrictToSchemaDropdownProps {
  schemas: Array<TagSchema>;
  onSelectSchema: (selectedSchema: TagSchema | null) => void;
  selectedSchema?: TagSchema | null;
}

function RestrictToSchemaDisplayName(props: {
  selectedSchema?: TagSchema | null;
  clearSelectedSchema: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}): JSX.Element {
  const [cancelButtonHover, setCancelButtonHover] = useState(false);
  if (props.selectedSchema) {
    return (
      <div className={css(styles.nameAndCancelButton)}>
        <span>{props.selectedSchema.name}</span>
        <BenchlingIcon
          className={classNames(css(styles.cancelButton), {
            [css(styles.cancelButtonHover)]: cancelButtonHover,
          })}
          dataTestAttrs={{
            component: 'RestrictToSchemaDisplayName',
            element: 'svg',
            key: 'clearRestrictToSchema',
          }}
          icon="close"
          onClick={props.clearSelectedSchema}
          onMouseOver={() => {
            setCancelButtonHover(true);
          }}
          onMouseOut={() => {
            setCancelButtonHover(false);
          }}
        />
      </div>
    );
  } else {
    return <span className={css(styles.restrictToSchema)}>Restrict to Schema</span>;
  }
}

export default function RestrictToSchemaDropdown({
  schemas,
  onSelectSchema,
  selectedSchema,
}: RestrictToSchemaDropdownProps): JSX.Element {
  const clearSelectedSchema = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    onSelectSchema(null);
    event.stopPropagation();
  };
  return (
    <SelectDropdown
      className={css(styles.restrictToSchemaSelectDropdown)}
      displayName={
        <RestrictToSchemaDisplayName
          selectedSchema={selectedSchema}
          clearSelectedSchema={clearSelectedSchema}
        />
      }
      disabled={schemas.length === 0}
      shouldGrowDisplayName={true}
      menu={
        <Menu value={selectedSchema}>
          {schemas.map((schema) => (
            <Option key={schema.id} onSelect={onSelectSchema} value={schema}>
              {schema.name}
            </Option>
          ))}
        </Menu>
      }
    />
  );
}

const styles = StyleSheet.create({
  restrictToSchemaSelectDropdown: {
    minWidth: '150px',
  },
  restrictToSchema: {
    fontStyle: 'italic',
    color: GRAY,
  },
  nameAndCancelButton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRight: `1px solid ${GRAY}`,
    paddingRight: '4px',
  },
  cancelButton: {
    color: GRAY_SEMIDARK,
    paddingLeft: '10px',
  },
  cancelButtonHover: {
    color: NEAR_BLACK,
  },
});
